import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Trans, withTranslation } from 'react-i18next'
import { Layout, notification, Alert, Col, Row, Modal } from 'antd'
import { clearMessage, showOfflineMerge, hideOfflineMerge, setShowSidePanel } from '../../actions'
import Head from '../layout/head'
import Breadcrumb from '../layout/breadcrumb'
import ErrorBoundary from '../layout/ErrorBoundary'
import CatalogOrderMergeModal from '../catalog/merge/catalog-order-merge-modal'
import CatalogEstimate from '../catalog/catalog-estimate'
import CatalogQuickCart from '../catalog/catalog-quick-cart'
import DefaultFooter from './footer/DefaultFooter'
import DesktopHeader from './header/DesktopHeader'
import MobileHeader from './header/MobileHeader'
import { ROLES } from '../../constants/AuthConstants'
import { getRolename } from '../../lib/AuthUtils'

const { Header, Content, Footer } = Layout

class DefaultLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      access: false,
      showingProducts: this.props.products && this.props.products.data,
    }
  }

  handleCollapse = (value) => {
    this.props.setShowSidePanel(value)
  }

  componentDidUpdate(prevProps) {
    const { t, message, clearMessage, products } = this.props

    if (products !== prevProps.products) {
      const showingProducts = products && products.data
      this.setState({ showingProducts })
    }

    if (message) {
      const translatedMessage = {
        ...message,
        message: t(message.message),
        description: t(
          message.description.statusCode ? message.description.message : message.description,
        ),
      }
      notification.open(translatedMessage)
      clearMessage()
    }
  }

  render() {
    const { t, children, bc, offline, ordersToMerge, isMobile } = this.props
    const { title = t('Iturria - Catalog'), hideBCTitle, isPurchaseAllowed } = this.props
    const { showingProducts } = this.state

    return (
      <Layout className='layout' style={{ height: '100vh' }}>
        {offline && <Alert message={t('Offline')} banner />}
        {!offline &&
          ordersToMerge &&
          (ordersToMerge.pedidosToMerge.length > 0 ||
            ordersToMerge.cotizaciontesToMerge.length > 0) && (
            <a
              onClick={() => {
                this.props.showOfflineMerge()
              }}
            >
              <Alert message={t('Orders to merge')} banner />
            </a>
          )}

        <Modal
          open={this.props.showOfflineMergeModal}
          maskClosable={false}
          closable={true}
          wrapClassName='catalog-order-merge-modal'
          footer={null}
          width='90%'
          title={
            <div className='catalog-order-merge-title'>
              <span>
                <Trans>Conflict Resolution</Trans>
              </span>
            </div>
          }
          onCancel={() => this.props.hideOfflineMerge()}
        >
          <CatalogOrderMergeModal />
        </Modal>

        <Head title={title} />

        <Header
          className={`hidden-print header-shadow ${showingProducts && isMobile ? 'mobile-header-searchbox' : ''}`}
        >
          {isMobile ? <MobileHeader /> : <DesktopHeader showSearchBox={showingProducts} />}
        </Header>

        {bc && !isMobile && <Breadcrumb bc={bc} />}

        <Content className={`${isMobile ? 'mt-2' : ''}`}>
          <ErrorBoundary>
            {title && !hideBCTitle && (
              <Row>
                <Col style={{ paddingLeft: '8px' }}>
                  <h4 className='content-title'>{title}</h4>
                </Col>
              </Row>
            )}
            {children}
          </ErrorBoundary>
        </Content>

        {isPurchaseAllowed && (
          <>
            <CatalogEstimate isMobile={isMobile} />
            <CatalogQuickCart isMobile={isMobile} />
          </>
        )}

        <Footer>
          <DefaultFooter isMobile={isMobile} />
        </Footer>
      </Layout>
    )
  }
}

const mapStateToProps = ({ common, catalog, auth }) => {
  const { message } = common
  const { offline, ordersToMerge, showOfflineMerge, products, showSidePanel } = catalog
  const showOfflineMergeModal = showOfflineMerge
  return {
    isPurchaseAllowed: getRolename(auth) === ROLES.SALESMAN || getRolename(auth) === ROLES.CLIENT,
    message,
    offline,
    ordersToMerge,
    showOfflineMergeModal,
    products,
    showSidePanel,
  }
}

export default connect(mapStateToProps, {
  clearMessage,
  showOfflineMerge,
  hideOfflineMerge,
  setShowSidePanel,
})(withTranslation()(DefaultLayout))
